/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'l4-policy';
const componentName = 'l4-policy-set';
const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const columnTitleNumberRules = `${prefix}.columnTitleNumberRules`;

export const ENGLISH = {
    [headerLabel]: 'L4 Policy Set',
    [columnTitleNumberRules]: '# Rules in L4 Connection Policy',
};
